<template>
  <div>
    <!-- 面包屑导航 -->
  <div class="flexc-cen-x fixed" >
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
      <el-option
        v-for="item in DianList"
        :key="item.ID"
        :label="item.StoresName"
        :value="item.ID">
      </el-option>
    </el-select>
  </div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="flex-spc-x" style="padding-top:30px">
      <div>
        <el-form-item label="搜索：">
          <el-input size="mini" v-model="selectName" placeholder="输入优惠券名称"></el-input>
        </el-form-item>
        <el-form-item label="">
            <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button size="mini" type="primary" v-if="q1 == true" icon="el-icon-plus" @click="handleEdit()" >添加优惠券</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="'进行中'" name="1" >
        </el-tab-pane>
        <el-tab-pane :label="'未开始'" name="2" >
        </el-tab-pane>
        <el-tab-pane :label="'已过期'" name="3" >
        </el-tab-pane>
        <el-tab-pane :label="'已失效'" name="4" >
        </el-tab-pane>
        <el-tab-pane :label="'未发布'" name="5" >
        </el-tab-pane>
    </el-tabs>
    <div style="height:65vh;overflow:auto;width:100%">
    <!--列表-->
    <el-table  :data="tableData" size="small" highlight-current-row v-loading="loading"   element-loading-text="拼命加载中" style="width: 100%;">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
        <el-table-column  prop="Title" :label="WZCDName+'名称'">
            
        </el-table-column>
        <el-table-column  prop="Ctype" :label="WZCDName+'类型'">
          <template slot-scope="scope">
               <div v-if="scope.row.Ctype == 0 " >会员卡</div>
              <div v-if="scope.row.Ctype == 1"  >{{WZXMName}}</div>
           </template>
        </el-table-column>
        <el-table-column  prop="DDPrice" label="订单价格" align="center" >
        </el-table-column>
        <el-table-column  prop="preferentialType" label="优惠类别" align="center" >
          <template slot-scope="scope">
            <div class="flex-xy">
              <div v-if="scope.row.preferentialType == 2 " style="margin-top:5px;">减免</div>
              <div v-if="scope.row.preferentialType == 1" style="margin-top:5px;">打折</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column  prop="addTime" label="优惠：" align="center" >
          <template slot-scope="scope">
            <div class="flex-xy">
              <div v-if="scope.row.preferentialType == 2 " style="margin-top:5px;">{{scope.row.preferentialvalue}}元</div>
              <div v-if="scope.row.preferentialType == 1 " style="margin-top:5px;">{{scope.row.preferentialvalue*10}}折</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="135"  prop="startTime" label="开始时间" >
        </el-table-column>
        <el-table-column width="135"  prop="endTime" label="结束时间" >
        </el-table-column>
        <el-table-column  prop="Note" label="简介" >
        </el-table-column>
        <el-table-column  prop="allCount" label="总张数" >
        </el-table-column>
        <el-table-column  prop="ylcount" label="已领张数" >
        </el-table-column>
      <el-table-column align="center" label="操作" width="360" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleShow(scope.row)">详情</el-button>
          <el-button v-if="(activeName == 5 || activeName == 2) && q2 == true" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button v-if="activeName == 5 && q3 == true"  type="warning" plain size="mini" @click="fabu(scope.row)">发布</el-button>
          <el-button  v-if="activeName != 4 && q4 == true" type="info" plain size="mini" @click="handlejie(scope.row)">作废</el-button>
          <el-button size="mini" v-if="activeName != 1 && activeName !=3 && q5 == true" type="info" @click="deleteUser(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="50%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
        <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" style="padding-bottom:100px">
          <el-form-item :label="WZCDName+'类型：'" prop="Title">
            <el-radio-group v-model="editForm.Ctype">
                    <el-radio label="0">会员卡</el-radio>
                    <el-radio label="1">{{WZXMName}}</el-radio>
                </el-radio-group>
            </el-form-item>  
          <el-form-item :label="WZCDName+'名称：'" prop="Title">
            <el-input size="small" v-model="editForm.Title" auto-complete="off" placeholder="请输入名称"  style="width: 215px"></el-input>
            </el-form-item>
            <el-form-item label="优惠方式：" prop="preferentialType">
                <el-radio-group v-model="editForm.preferentialType">
                    <el-radio label="1">折扣</el-radio>
                    <el-radio label="2">减免</el-radio>
                </el-radio-group>
            </el-form-item> 
              <el-form-item  label="优惠：" prop="preferentialvalue">
                <el-input v-if="editForm.preferentialType == 1"  size="small" v-model="editForm.preferentialvalue" auto-complete="off" placeholder="请输入0~1之间的数"  style="width: 215px"></el-input>
                <el-input v-if="editForm.preferentialType == 2"  size="small" v-model="editForm.preferentialvalue" auto-complete="off" placeholder="请输入金额"  style="width: 215px"></el-input>

            </el-form-item>
            <el-form-item label="关联卡种：" prop="CardIDs" v-if="isCard == 1 && editForm.Ctype==0">
                <el-select v-model="editForm.CardIDs" multiple placeholder="请选择" size="small" style="width:90%">
                <el-option
                    v-for="item in cardList"
                    :key="item.ID"
                    :label="item.CardName"
                    :value="item.ID">
                </el-option>
                </el-select>
            
            </el-form-item>
            <el-form-item  :label="'关联'+WZXMName+'：'"  prop="ObjIDs" v-if="editForm.Ctype==1">
                <el-select v-model="editForm.ObjIDs" multiple placeholder="请选择" size="small" style="width:90%">
                <el-option
                    v-for="item in projectList"
                    :key="item.ID"
                    :label="item.ProjectName"
                    :value="item.ID">
                </el-option>
                </el-select>
            
            </el-form-item>
            <el-form-item label="订单金额：" prop="DDPrice">
                <el-input size="small" v-model="editForm.DDPrice" auto-complete="off" placeholder="请输入订单金额"  style="width: 215px"></el-input>
            </el-form-item>
            <el-form-item label="发放总量：" prop="allCount">
                <el-input size="small" v-model="editForm.allCount" auto-complete="off" placeholder="请输入发放总量"  style="width: 215px"></el-input> 张
            </el-form-item>
            <el-form-item label="每人领取限制：" prop="xgCount">
                <el-input size="small" v-model="editForm.xgCount" auto-complete="off" placeholder="请输入每人领取限制"  style="width: 215px"></el-input>
                张
            </el-form-item>
            <el-form-item label="有效期：" prop="YXType">
               <el-radio-group v-model="editForm.YXType">
                    <el-radio label="1">固定有效期</el-radio>
                    <el-radio label="2">领取当日开始计算有效期</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="editForm.YXType == 1" label="生效日期：" prop="YXstartTime">
                <el-date-picker
                        size="small"
                          v-model="editForm.YXstartTime"
                          type="datetime"
                          value-format="yyyy/MM/dd HH:mm:ss"
                         placeholder="选择日期时间"
                         default-time="08:00:00">
                </el-date-picker>
            </el-form-item>
             <el-form-item v-if="editForm.YXType == 1" label="过期时间：" prop="YXendTime">
                <el-date-picker
                        size="small"
                          v-model="editForm.YXendTime"
                          type="datetime"
                          value-format="yyyy/MM/dd HH:mm:ss"
                         placeholder="选择日期时间"
                         default-time="08:00:00">
                </el-date-picker>
            </el-form-item>
             <el-form-item v-if="editForm.YXType == 2" label="有效天数：" prop="YXdays">
                    <el-input size="small" v-model="editForm.YXdays" auto-complete="off" placeholder="请输入有效天数"  style="width: 215px"></el-input>
            </el-form-item>
             <el-form-item label="领券开始时间：" prop="startTime">
                  <el-date-picker
                        size="small"
                          v-model="editForm.startTime"
                          type="datetime"
                          value-format="yyyy/MM/dd HH:mm:ss"
                         placeholder="选择日期时间"
                         default-time="08:00:00">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="领券结束时间：" prop="endTime">
                  <el-date-picker
                        size="small"
                          v-model="editForm.endTime"
                          type="datetime"
                          value-format="yyyy/MM/dd HH:mm:ss"
                         placeholder="选择日期时间"
                         default-time="08:00:00">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="使用设置：" prop="applyType">
                <el-checkbox-group size="small" v-model="checkList">
                            <el-checkbox label="1">访客</el-checkbox>
                            <el-checkbox label="2">会员</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="开启线上支付：" prop="isPay">
                <el-radio-group v-model="editForm.isPay">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="0">否</el-radio>
                </el-radio-group>
            </el-form-item> 
            <el-form-item v-if="editForm.isPay == 1" label="线上支付价格：" prop="payPrice">
                 <el-input size="small" v-model="editForm.payPrice" auto-complete="off" placeholder="请输入支付价格"  style="width: 215px"></el-input>
            </el-form-item> 
            <el-form-item label="简介:" prop="Note">
               <el-input size="small" v-model="editForm.Note" auto-complete="off" placeholder="请输入简介"  style="width: 215px"></el-input>
            </el-form-item>
            <el-form-item label="使用说明:" prop="Syinfo">
                <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.Syinfo" style="width:350px"></el-input>
            </el-form-item>
       
        </el-form>
        
        <div class="demo-drawer__footer flex-r-x"  style="width:50%">
          <el-button size="small" @click="closeDialog"      style="margin-right:20px">取消</el-button>
          <el-button
          style="margin-right:20px"
              size="small"
              type="primary"
              @click="submitForm('editForm',1)"
              >保存</el-button
            >
          <el-button
            v-if="title=='添加'"
            style="margin-right:20px"
            size="small"
            type="primary"
            @click="submitForm('editForm',2)"
            >保存并发布</el-button
          >
        </div>
    </el-drawer>
    <el-drawer title="详情" :visible.sync="showMain" :direction="direction" size="50%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
        <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" style="padding-bottom:100px">
            <el-form-item :label="WZCDName+'名称：'" prop="Title">
              <span>{{editForm.Title}}</span>
        
            </el-form-item>
            <el-form-item :label="WZCDName+'类型：'" prop="Title">
              <span v-if="editForm.Ctype == 0">会员卡</span>
              <span v-if="editForm.Ctype == 1">{{WZXMName}}</span>
        
            </el-form-item>
            <el-form-item label="优惠方式：" prop="preferentialType">
              <span v-if="editForm.preferentialType == 1">折扣</span>
              <span v-if="editForm.preferentialType == 2">减免</span>
              
            </el-form-item> 
              <el-form-item  label="优惠：" prop="preferentialvalue">
                <span  v-if="editForm.preferentialType == 1" >{{editForm.preferentialvalue*10}}折</span>
                <span  v-if="editForm.preferentialType == 2" >{{editForm.preferentialvalue}}元</span>
  
            </el-form-item>
            <el-form-item label="关联卡种：" prop="CardIDs" v-if="isCard == 1 && editForm.Ctype==0">
              <span v-if="editForm.CardNames != ''">{{editForm.CardNames}}</span>
              <span v-else>支持所有卡种</span>
            </el-form-item>
            <el-form-item :label="'关联'+WZXMName+'：'" prop="ObjIDs" v-if="editForm.Ctype == 1">
              <span v-if="editForm.ObjNames != ''">{{editForm.ObjNames}}</span>
              <span v-else>支持所有{{WZXMName}}</span>
            </el-form-item>
            
            <el-form-item label="订单金额：" prop="DDPrice">
              <span>{{editForm.DDPrice}}元</span>
              
            </el-form-item>
            <el-form-item label="发放总量：" prop="allCount">
              <span>{{editForm.allCount}}张</span>
          
            </el-form-item>
              <el-form-item label="已领张数" prop="allCount">
              <span>{{editForm.ylcount}}张</span>
          
            </el-form-item>
            <el-form-item label="每人领取限制：" prop="xgCount">
              <span>{{editForm.xgCount}}</span>张
            </el-form-item>
            <el-form-item label="有效期：" prop="YXType">
                <span v-if="editForm.YXType == 1" >固定有效期</span>
                <span v-if="editForm.YXType == 2">领取当日开始计算有效期</span>
            </el-form-item>
            <el-form-item v-if="editForm.YXType == 1" label="生效日期：" prop="YXstartTime">
             <span>{{editForm.YXstartTime}}</span>
            </el-form-item>
             <el-form-item v-if="editForm.YXType == 1" label="过期时间：" prop="YXendTime">
                 <span>{{editForm.YXendTime}}</span>

            </el-form-item>
             <el-form-item v-if="editForm.YXType == 2" label="有效天数：" prop="YXdays">
              <span>{{editForm.YXdays}}</span>天
                 
            </el-form-item>
             <el-form-item label="领券开始时间：" prop="startTime">
               <span>{{editForm.startTime}}</span>
              
            </el-form-item>
            <el-form-item label="领券结束时间：" prop="endTime">
              <span>{{editForm.endTime}}</span>
               
            </el-form-item>
            <el-form-item label="使用设置：" prop="applyType">
                <el-checkbox-group size="small"  disabled v-model="checkList">
                            <el-checkbox label="1">访客</el-checkbox>
                            <el-checkbox label="2">会员</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="开启线上支付：" prop="isPay">
                <span v-if="editForm.isPay == 1">是</span>
                  <span v-if="editForm.isPay == 0">否</span>
                
           
            </el-form-item> 
            <el-form-item v-if="editForm.isPay == 1" label="线上支付价格：" prop="payPrice">
              <span>{{editForm.payPrice}}</span>
              
            </el-form-item> 
            <el-form-item label="简介:" prop="Note">
                <div v-if="editForm.Note !=''">{{editForm.Note}}</div>
                <div v-else>暂无</div>
            </el-form-item>
            <el-form-item label="使用说明:" prop="Syinfo">
               <div v-if="editForm.Syinfo !=''">{{editForm.Syinfo}}</div>
                <div v-else>暂无</div>

            </el-form-item>
       
        </el-form>
        
        
    </el-drawer>
      <el-dialog title="修改密码" :visible.sync="passShow" width="40%" >
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="密码" prop="deptNo">
          <el-input size="small" placeholder="请输入密码" v-model="Pwd" show-password auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="topass()">保存</el-button>
      </div>
    </el-dialog>
      <el-dialog title="充值" :visible.sync="chongShow" width="40%" >
      <el-form label-width="120px">
        <el-form-item label="充值金额" prop="money">
          <el-input size="small" placeholder="请输入充值金额" v-model="money"  auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="ADDmoney()">充值</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import CropperImage from "../../components/CropperImage";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
    activeName:'1',
      DianList:[],
        quanxian:false,
      formValidate: {
        mainImage: "",
      },
      showMain:false,
      props: {
          children: 'listsub',
          label: 'Name'
        },
       direction: "ltr",
      passShow:false,
      money:'',
          checkList:['1','2'],
     cardList:[],
     projectList:[],
     typeList:[
         {
             ID:'1',
             name:''
         },
        {
             ID:'1',
             name:''
         },
                  {
             ID:'1',
             name:''
         },
                  {
             ID:'1',
             name:''
         },
                  {
             ID:'1',
             name:''
         },
     ],
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      typeList:[],
      Pwd:'',
      RoleID:'',
      SelectStoresID:localStorage.getItem("StoresID"),
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      WZCDName:'优惠券',
      editForm: {
          Title:'',
          PicUrl:'',
          preferentialType:'1',
          CardIDs:'',
          YXType:'2',
          isPay:'0'
      },
      rules: {
        Title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
        allCount: [{ required: true, message: '请输入发放总量', trigger: 'blur' }],
        DDPrice: [{ required: true, message: '请输入订单金额', trigger: 'blur' }],
        //   Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        //   Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        //   pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        //   money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
        //   ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      selectName:'',
      WZXMName:'',
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
            isCard:localStorage.getItem('isCard'),
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    if(localStorage.getItem('isAdmin') == 1){
          
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 =true
   
      }
      this.WZXMName = localStorage.getItem('WZXMName')
      this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {

            if(items == 1704)
            this.q1  =true
            if(items == 1705)
            this.q2 = true
            if(items == 1706)
            this.q3 = true
            if(items == 1707)
            this.q4 = true
            if(items == 1708)
            this.q5 = true

      })
      
          this.getDianList()
    this.getCardList()
    this.getProjectList()
    this.getList()

    //  this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleShow(row){
          this.editForm = row
          this.checkList=[];       
          var str1 = row.applyType;
          var arr1 = str1.split(',');
          if(arr1.length>0){
            this.$set( this,'checkList',arr1);
          }
          if(this.editForm.CardIDs != ''){
            this.editForm.CardIDs = this.editForm.CardIDs.split(",")
        } 
        if(this.editForm.ObjIDs != ''){
            this.editForm.ObjIDs = this.editForm.ObjIDs.split(",")
        } 
        this.showMain = true
    },
      handlejie(row){
        this.$confirm("确定要作废吗?", "提示", {
            confirmButtonText: "作废且已领取可以使用",
            cancelButtonText: "作废已领取未使用也作废",
            type: "warning",
        })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          CouponActivityID:row.ID,
          state:3
        }
        var that = this
        this.ajax('editCouponActivitystate.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "作废成功",duration:2000,
              });
              that.pageparm = {
                            currentPage: 1,
                            pageSize: 10,
                            total: 0,
              },
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
           var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          CouponActivityID:row.ID,
          state:4
        }
        var that = this
        this.ajax('editCouponActivitystate.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "作废成功",duration:2000,
              });
            that.pageparm ={
                            currentPage: 1,
                            pageSize: 10,
                            total: 0,
    },
              that.getList()
              //  that.provinceList = res.data
            }

        })
        });
    
      },
      fabu(row){
        this.$confirm("确定要发布吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          CouponActivityID:row.ID,
          state:2
        }
        var that = this
        this.ajax('editCouponActivitystate.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "发布成功",duration:2000,
              });
            that.pageparm ={
                            currentPage: 1,
                            pageSize: 10,
                            total: 0,
    },
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
      },
      handleClick(){
         this.pageparm ={
                            currentPage: 1,
                            pageSize: 10,
                            total: 0,
    },
          this.getList()
      },
    getCardList(){
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CardType:0
      }
  
      var that = this
      this.ajax('getListMemberCard.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         
                that.cardList= res.data
    
          } 
       })

    },

getProjectList(){
   var data = { 
       SelectStoresID:this.SelectStoresID,        
       token: localStorage.getItem("token"),
       StoresID:localStorage.getItem("StoresID"),
       pages:1,
       psize:9999,
       ProjectTypeID:0
     // StaffTypeID:this.active
 }

 
   var that = this
 this.ajax('getListProject.aspx',JSON.stringify(data),"POST",function(res){
     if (res.orsuccess == "1") {

           that.projectList = res.data
         
     } 

 })
 },
      tosetting(){
         this.$router.go(-1)
      },
        getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
},

  changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    
      this.getList()
    },
        deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          CouponActivityID:row.ID,
          isdel:1
        
        }
        var that = this
        this.ajax('editCouponActivityisdel.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
             that.pageparm = {
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },


    handlePassword(){
        this.quanxian = true
    },
    handleEdit(row){
          if (row != undefined && row != 'undefined') {

                this.title = '编辑'
        
                this.editForm = row
                 let date = new Date(this.editForm.startTime);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hour = date.getHours();
                let minute = date.getMinutes();
                let second = date.getSeconds();
                if (month < 10) {
                  month = '0' + month;
                }
                if (day < 10) {
                  day = '0' + day;
                }
                if (hour < 10) {
                  hour = '0' + hour;
                }
                if (minute < 10) {
                  minute = '0' + minute;
                }
                if (second < 10) {
                  second = '0' + second;
                }
          
                this.editForm.startTime =  year + "/" + month + "/" + day + " " + hour + ":" + minute + ":" + second;
               
                 date = new Date(this.editForm.endTime);
                 year = date.getFullYear();
                 month = date.getMonth() + 1;
                 day = date.getDate();
                 hour = date.getHours();
                 minute = date.getMinutes();
                 second = date.getSeconds();
                if (month < 10) {
                  month = '0' + month;
                }
                if (day < 10) {
                  day = '0' + day;
                }
                if (hour < 10) {
                  hour = '0' + hour;
                }
                if (minute < 10) {
                  minute = '0' + minute;
                }
                if (second < 10) {
                  second = '0' + second;
                }
                 this.editForm.endTime = year + "/" + month + "/" + day + " " + hour + ":" + minute + ":" + second;
                this.checkList=[];       
                var str1 = row.applyType;
                var arr1 = str1.split(',');
                if(arr1.length>0){
                    this.$set( this,'checkList',arr1);
                }
                if(this.editForm.CardIDs != ''){
                  
                    this.editForm.CardIDs = this.editForm.CardIDs.split(",")
                }
                if(this.editForm.ObjIDs != ''){
                  
                  this.editForm.ObjIDs = this.editForm.ObjIDs.split(",")
              }
                
          } else {
              this.title = '添加'
               this.editForm = {
                    Title:'',
                    PicUrl:'',
                    preferentialType:'1',
                    CardIDs:'',
                    YXType:'2',
                    isPay:'0',
                    preferentialvalue:'',
                    DDPrice:'',
                    allCount:'',
                    YXstartTime:'',               
                    YXendTime:'',
                    YXdays:'',
                    startTime:'',
                    endTime:'',
                    payPrice:'',
                    state:'',
                    Syinfo:'',
                    Note:'',
                    xgCount:1,
                    Ctype:'0',
                    ObjIDs:'',
                }
                this.checkList =['1','2']
             
          }
          this.editFormVisible = true
    },
    handleCheckChange(data, checked, indeterminate) {
        console.log(data, checked, indeterminate);
         console.log(this.$refs.tree.getCheckedNodes());
      },

    getList(){

    //  this.tableLoading = true
       var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          selectName:this.selectName,
          AcTimeState:this.activeName,
          pages:this.formInline.page,
          psize:this.formInline.limit,

      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListCouponActivity.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                that.pageparm.total = res.allcount
                that.tableData.forEach(items => {
                    items.startTime = items.startTime.replace(/\//g, '-')
                   items.endTime = items.endTime.replace(/\//g, '-')
                });
                 loading.close();
          } 

      })
  
    },

    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
       this.pageparm ={
                            currentPage: 1,
                            pageSize: 10,
                            total: 0,
                        },
        this.getList()
    },
    //显示编辑界面

    // 编辑、增加页面保存方法
    submitForm(editData,state) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            if(Number(this.editForm.xgCount) > Number(this.editForm.allCount) ){
              console.log('限购',this.editForm.xgCount)
               console.log(this.editForm.allCount)
               this.$message({
                    message: "限购数量不能大于发放总量",
              });
              return
            }
            if(this.editForm.xgCount<1){
               this.$message({
                    message: "限购数量必须大于0",
              });
              return
            }
            var data = this.editForm
            if(this.editForm.CardIDs){
                var card = [...this.editForm.CardIDs]
                data.CardIDs =  card.join(",")
            } 
            if(this.editForm.ObjIDs){
                var objs = [...this.editForm.ObjIDs]
                data.ObjIDs =  objs.join(",")
            } 
             
               data.applyType= this.checkList.join()

                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.LoginID = localStorage.getItem("LoginID")
                data.SelectStoresID  = this.SelectStoresID
                data.state = state
                var that = this
            if(this.title == '添加'){
                this.ajax('addCouponActivity.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.editFormVisible = false
                         that.pageparm ={
                            currentPage: 1,
                            pageSize: 10,
                            total: 0,
                        },
                        that.getList()
                     }

                })

            }else {
                data.CouponActivityID =  this.editForm.ID
                 this.ajax('editCouponActivity.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
                          that.pageparm ={
                            currentPage: 1,
                            pageSize: 10,
                            total: 0,
                        },
                        that.editFormVisible = false
                        that.getList()
                     }

                })
            }
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/discoun/discoun.vue